import { NavLink } from 'react-router'
import { PhoneScreenshotFrame } from './LandingScreenshotFrames'

const guestSteps = [
  {
    step: '01',
    title: 'Guests open the real meeting',
    description:
      'They see the actual upcoming agenda - no account, no login wall, nothing between them and your club',
  },
  {
    step: '02',
    title: 'They tap Join when they are ready',
    description:
      'The join action lives on the same public schedule they already understand',
  },
  {
    step: '03',
    title: 'The account is created from email',
    description:
      'They confirm the sign-up link and return to the club schedule, ready for the next meeting',
  },
]

export default function LandingGrowth() {
  return (
    <div className="bg-gray-900 py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="text-base font-semibold leading-7 text-indigo-400">
            For Presidents and VPs of Membership
          </h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Your schedule is your best recruiting page
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-300">
            Guests often never show up - joining feels intimidating, and they
            don&apos;t feel like part of the club yet. Speech Agenda turns your
            schedule into the welcome
          </p>
        </div>
        <div className="mx-auto mt-16 grid max-w-5xl grid-cols-1 items-center gap-x-16 gap-y-12 sm:mt-20 lg:mt-24 lg:grid-cols-2">
          <div className="relative mx-auto w-full max-w-md">
            <PhoneScreenshotFrame
              src="/public-person-join-meeting.png"
              alt="Public meeting schedule with a Join button for guests"
              className="max-w-[16rem] -rotate-2"
              imageStyle={{ marginLeft: 13, marginTop: 16 }}
            />
            <div className="mt-6 rounded-2xl bg-white p-3 shadow-2xl shadow-indigo-950/50 ring-1 ring-white/20 lg:absolute lg:-right-8 lg:bottom-10 lg:mt-0 lg:w-64">
              <img
                src="/guest-enter-your-email-and-account-is-created.png"
                alt="Account activation link sent after guest enters their email"
                className="w-full rounded-xl"
              />
            </div>
          </div>
          <div>
            <dl className="space-y-6">
              {guestSteps.map((step) => (
                <div
                  key={step.title}
                  className="rounded-2xl border border-white/10 bg-white/5 p-5">
                  <dt className="flex items-center gap-x-4 text-base font-semibold leading-7 text-white">
                    <span className="flex h-10 w-10 flex-none items-center justify-center rounded-lg bg-indigo-500 text-sm font-bold text-white">
                      {step.step}
                    </span>
                    {step.title}
                  </dt>
                  <dd className="mt-3 text-base leading-7 text-gray-300">
                    {step.description}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
        <div className="mx-auto max-w-2xl">
          <div className="mt-14 text-center">
            <p className="text-lg leading-8 text-gray-300">
              More guests who show up, more who become members - visible
              momentum toward your club&apos;s growth goals
            </p>
            <NavLink
              to="/clubs"
              className="mt-4 inline-block text-sm font-semibold leading-6 text-indigo-400 hover:text-indigo-300">
              See a public club page <span aria-hidden="true">→</span>
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  )
}
